import { z } from "zod";
import { CommunityAuthor } from "./community/author.js";
import { ShareContentType } from "./community/share-content.js";
export const NotificationContentKind = ShareContentType;
export const NotificationData = z
    .object({
    kind: z.string().optional(),
    action: z.string().optional(),
    contentType: NotificationContentKind.optional(),
    communityActor: CommunityAuthor.optional(),
    actorCount: z.number().int().nonnegative().optional(),
})
    .passthrough();
export const GetNotificationsQuery = z.object({
    include_dismissed: z.string().optional(),
    limit: z.string().optional(),
});
export const NotificationItem = z.object({
    id: z.string(),
    userId: z.string(),
    title: z.string(),
    body: z.string(),
    data: NotificationData.nullable(),
    deepLink: z.string().nullable(),
    createdAt: z.string(),
    dismissedAt: z.string().nullable(),
});
export const GetNotificationsResponse = z.array(NotificationItem);
export const NotificationParams = z.object({ id: z.string() });
export const DismissNotificationResponse = z.object({});
export const DismissAllNotificationsResponse = z.object({
    ok: z.literal(true),
    dismissed: z.number().int().nonnegative(),
});
export const WebPushPublicKeyResponse = z.object({
    configured: z.boolean(),
    publicKey: z.string().nullable(),
});
export const WebPushSubscriptionKeys = z.object({
    p256dh: z.string().min(1),
    auth: z.string().min(1),
});
export const RegisterWebPushSubscriptionRequest = z.object({
    endpoint: z.string().url(),
    expirationTime: z.number().nullable().optional(),
    keys: WebPushSubscriptionKeys,
});
export const RegisterWebPushSubscriptionResponse = z.object({
    ok: z.literal(true),
});
export const DeleteWebPushSubscriptionRequest = z.object({
    endpoint: z.string().url(),
});
export const DeleteWebPushSubscriptionResponse = z.object({
    ok: z.literal(true),
});
//# sourceMappingURL=notifications.js.map